module.exports = __webpack_public_path__ + "static/media/upload-default-image.7e2fc3ec.png";